import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Briefcase, MapPin, Users } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { careers as mockCareers } from '@/data/mock';

const AdminJobsPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      // Get application counts per job from Supabase
      const { data: apps, error } = await supabase
        .from('job_applications')
        .select('job_id');

      if (error) throw error;

      // Count applications per job_id
      const counts = {};
      (apps || []).forEach(app => {
        counts[app.job_id] = (counts[app.job_id] || 0) + 1;
      });

      // Merge mock careers with application counts
      const jobsWithCounts = mockCareers.map(job => ({
        ...job,
        application_count: counts[job.id] || 0,
      }));

      setJobs(jobsWithCounts);
    } catch (error) {
      console.error('Failed to fetch jobs:', error);
      setJobs(mockCareers.map(job => ({ ...job, application_count: 0 })));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <Card>
        <CardContent className="p-6">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {jobs.map((job) => (
                <Card key={job.id} className="hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-3 mb-4">
                      <div className="p-2 bg-red-50 rounded-lg">
                        <Briefcase className="w-5 h-5 text-red-600" />
                      </div>
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-900">{job.title}</h3>
                        <p className="text-sm text-gray-600 flex items-center gap-1 mt-1">
                          <MapPin className="w-4 h-4" />
                          {job.location}
                        </p>
                      </div>
                    </div>

                    <div className="space-y-2 text-sm">
                      <p className="text-gray-600"><span className="font-medium">Type:</span> {job.type}</p>
                      <p className="text-gray-600"><span className="font-medium">Department:</span> {job.department}</p>
                      <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                        <div className="flex items-center gap-2 text-gray-700">
                          <Users className="w-4 h-4" />
                          <span className="font-semibold">{job.application_count || 0}</span>
                          <span className="text-gray-600">applicants</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </AdminLayout>
  );
};

export default AdminJobsPage;
